import { bbox, circle } from "@turf/turf";

import { MapBounds } from "~/modules/map/components/MapButtonFitBounds/types";
import { NETHERLANDS_BOUNDS } from "~/modules/map/mapConstants";
import { PLANNER_MAP_VISIT_FIELDWORKER_RADIUS_KM } from "~/modules/plannerV2/constants/map";

export function calculateAreaDetailBounds(area: { location: GeoJSON.Point } | undefined | null): MapBounds {
    if (!area) {
        return NETHERLANDS_BOUNDS;
    }

    return { bbox: bbox(circle(area.location, PLANNER_MAP_VISIT_FIELDWORKER_RADIUS_KM)), kind: "area" };
}
